import React from 'react';

const Answer = ({answer}) => {
    return (
        <div>
            <div>
                {
                    answer.text
                }
            </div>
            
        </div>
    );
    
};

export default Answer;